import { useQuery } from 'react-query';
import { CustomerCalendarApi } from '../../CustomerCalendarApi';
import { UnbookedOrdersQueryKey } from '../../queryKeys';
import { UnbookedOrders } from '../../types';

export function useUnbookedOrdersQuery() {
    return useQuery<UnbookedOrders>(
        [UnbookedOrdersQueryKey],
        () => CustomerCalendarApi.getUnbookedOrders(),
        {
            refetchOnWindowFocus: false
        }
    );
}
